import currencyTypes from 'data/currency-types'

const getCurrency = (search, by = 'code') => {
    search = search.toString();
    
    return currencyTypes.find((type) => {
        return type[by] === search;
    });
}

export default getCurrency